import get from 'lodash/get'
import { ReduxState } from 'app-types'

import { ContractSignStatus, PreContractStatus } from '../../../constants/enums'

export const getContractPdf = (state: ReduxState): string => get(state, 'contract.contractPdf')

export const getContractSignStatus = (state: ReduxState): ContractSignStatus =>
  get(state, 'contract.contractSignStatus')

export const getPreContractPdf = (state: ReduxState): string =>
  get(state, 'contract.preContractPdf')

export const getPreContractStatus = (state: ReduxState): PreContractStatus =>
  get(state, 'contract.preContractStatus')
